module.exports = __webpack_public_path__ + "img/11.4c9bb549.png";